export const features = [
    {
        "name": { 
            "en": "Pre-Inspection", 
            "es": "Pre-Inspección", 
            "pt": "Pré-Inspeção" 
        },
        "img": "pre-inspection.svg"
    },
    {
        "name": { 
            "en": "FNOL", 
            "es": "FNOL", 
            "pt": "FNOL" 
        },
        "img": "fnol.svg"
    },
    {
        "name": { 
            "en": "AI Photo/Video Capture Apps", 
            "es": "Aplicaciones de Captura de Fotos/Vídeos con IA", 
            "pt": "Aplicativos de Captura de Fotos/Vídeos com IA" 
        },
        "img": "photo-video-capture-app.svg"
    },
    {
        "name": { 
            "en": "Claim Estimation", 
            "es": "Estimación de Reclamo", 
            "pt": "Estimativa de Sinistro" 
        },
        "img": "claim-estimation-white.svg"
    },
    {
        "name": { 
            "en": "Claim Review", 
            "es": "Revisión de Reclamo", 
            "pt": "Revisão de Sinistro" 
        },
        "img": "claim-review-white.svg"
    }
];


export const workflowIssues = [
    {
        icon: '/img/time-consumption-icon.png',
        title: 'Time Consuming',
    },
    {
        icon: '/img/inconsistent-assessment-icon.png',
        title: 'Inconsistent assessments',
    },
    {
        icon: '/img/customer-trust-issues-icon.png',
        title: 'Customer trust issues',
    },
    {
        icon: '/img/human-error-icon.png',
        title: 'Prone to human error',
    },
    {
        icon: '/img/disorganized-records-icon.png',
        title: 'Disorganized records',
    }
];

export const builtForList = [
    {
        icon: '/img/instant-damage-detection.png',
        title: 'Instant Damage Detection',
    },
    {
        icon: '/img/severity-estimation.png',
        title: 'Severity Estimation',
    },
    {
        icon: '/img/vehicle-condition-report.png',
        title: 'Automated Vehicle condition Report',
    },
    {
        icon: '/img/workflow-integration.png',
        title: 'Seamless workflow integration',
    },
    {
        icon: '/img/fraud-detection-capabilities.png',
        title: 'Fraud Detection Capabilities',
    }
];

export const stats = [
    {
        value: '90%',
        label: 'Faster Inspection'
    },
    {
        value: '50%',
        label: 'Reduction in Claim Disputes'
    },
    {
        value: '30%',
        label: 'Lower Operational Costs'
    },
    {
        value: '100%',
        label: 'Standarized reporting across locations'
    }
];

export const capabilities = [
    {
        icon: '/img/pre-inspection-icon.png',
        title: 'Pre-Inspection',
        text: 'Automatically detect & report pre-existing vehicle damage during policy issuance/renewal to avoid inflated claims in the future.'
    },
    {
        icon: '/img/FNOL-icon.png',
        title: 'FNOL',
        text: 'Enable customers to report damage via their smartphones, reducing processing time by 70%',
        link: '/fnol-automation'
    },
    {
        icon: '/img/Claim-estimation-and-review-icon.png',
        title: 'Claim Estimation and Review',
        text: 'Standardized estimation reports based on market values, generated within seconds.'
    },
    {
        icon: '/img/Workshop-coordination-icon.png',
        title: 'Workshop co-ordination',
        text: 'Automatically share the damage & claim estimation report with the workshop, eliminating the need for constant back & forth.'
    },
    {
        icon: '/img/Post-repair-validation.png',
        title: 'Re-inspection & post-repair validation',
        text: 'Automate inspections post-repair to validate before vs. after condition of the vehicles'
    }
];
